import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
export function parseDrawing(text) {
  return text.toLowerCase()
  // numbers
  .replace(/([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)/g, ' $1 ')
  // commands
  .replace(/([mnlbspc])/g, ' $1 ').trim().replace(/\s+/g, ' ').split(/\s(?=[mnlbspc])/).map(function (cmd) {
    return cmd.split(' ').filter(function (x, i) {
      return !(i && Number.isNaN(x * 1));
    });
  });
}